import React, { useEffect } from 'react';
// https://fluentsite.z22.web.core.windows.net/quick-start
import { HashRouter as Router, Redirect, Route } from 'react-router-dom';
import Privacy from './components/Privacy';
import TermsOfUse from './components/TermsOfUse';
import CoursePage from './pages/Course/CoursePage';
import { ROUTES } from './utils/constant';
import LoginPage from './pages/Login/LoginPage';
import MissionPage from './pages/Mission/MissionPage';
import CourseReportListPage from './pages/CourseReportList/CourseReportListPage';
import MissionReportList from './pages/MissionReportList';
import CourseReportDetailPage from './pages/CourseReportDetail/CourseReportDetailPage';
import MissionReportDetail from './pages/MissionReportDetail';
import UserListPage from './pages/UserList/UserListPage';
import MainPage from './pages/Main/MainPage';
import CourseDetailPage from './pages/CourseDetail/CourseDetailPage';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/system';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 361,
      md: 701,
      lg: 1201,
      xl: 1921,
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App (): React.ReactElement {
  useEffect(() => {
    console.log('Version', process.env.REACT_APP_VERSION);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />
      <Router>
        <Route exact path="/">
          <Redirect to={ROUTES.courses} />
        </Route>
        <Route exact path={ROUTES.login} component={LoginPage} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/termsofuse" component={TermsOfUse} />
        <Route exact path={ROUTES.courses} component={CoursePage} />
        <Route exact path={ROUTES.mission} component={MissionPage} />
        <Route exact path={ROUTES.courseReportList} component={CourseReportListPage} />
        <Route exact path={ROUTES.courseReportDetail} component={CourseReportDetailPage} />
        <Route exact path={ROUTES.userList} component={UserListPage} />
        <Route exact path={ROUTES.main} component={MainPage} />
        <Route exact path={ROUTES.courseDetail} component={CourseDetailPage} />
        <Route exact path={ROUTES.missionReportList} component={MissionReportList} />
        <Route exact path={ROUTES.missionReportDetail} component={MissionReportDetail} />
      </Router>
    </ThemeProvider>
  );
}
